import React, { useCallback, useEffect, useId, useRef, useState } from "react";
import classes from "./EditRequestPaper.module.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import Graybg from "../../UI/Graybg";
import Card from "../../UI/Card/Card";
import { Col, Row } from "react-bootstrap";
import DatePick from "../../Components/DatePicker/DatePicker";
import Select from "../../UI/Select/Select";
import SecBTN from "../../UI/SecBTN";
import Input from "../../UI/Input/Input";
import { subDays, setHours, setMinutes, getTime } from "date-fns";
// import MultiSelect from '../../UI/MultiSelect/MultiSelect';
import ConfirmationModal from "../../UI/ConfirmationModal/ConfirmationModal";
import SuccessModal from "../../UI/SuccessModal/SuccessModal";
import userService from "../../app/services/user.service";
import MultiSelectDropdown from "../../UI/MultiSelectDropdown/MultiSelectDropdown";
import Loader from "../../UI/loader/loader";
import SectionOption from "./SectionOption";
import Toast from "../../UI/Toast/Toast";
import { toast } from "react-toastify";
import { isEmpty } from "../../utils/custom_funtions";
import { useNavigate, useParams } from "react-router-dom";


const EditRequestPaper = React.forwardRef(() => {
  const user = JSON.parse(localStorage.getItem("user")).data.user;
  const navigate = useNavigate();
  const { pid } = useParams();
  const forms = useRef(null);
  const requestedData = {
    paper_id: "",
    paper_name: "",
    session_id: "",
    target_id: "",
    to_be_held_on: null,
    to_be_completed_by: null,
    to_be_final_by: null,
    start_date: null,
    end_date: null,
    paper_type: "",
    status: "1",
    paper_format_id: "",
    phase_id: "",
    syllabus_img:
      "https://quizmaster.motion.ac.in/ckfinder/userfiles/images/paper-images/no-image.png",
    created_by: user.user_id,
    pcenters: [],
    pclasses: [],
    batchsrel: [
      {
        batch_id: 0,
      },
    ],
    Sublist: [],
    Subjects: {},
  };
  const [showPopUp1, setShowPopUp1] = useState(false);
  const [showPopUp2, setShowPopUp2] = useState(false);
  const [showQDetails, setShowQDetails] = useState(false);
  // const [stream, setStream] = useState("");
  // const [selectedFormat, setSelectedFormat] = useState("");
  // const [selectSession, setSelectSession] = useState("");
  const [formatList, setFormatList] = useState([]);
  // const [selectedCenter, setSelectedCenter] = useState([]);
  // const [selectClasses, setSelectClasses] = useState([]);
  const [allFacultyList, setAllFacultyList] = useState([]);
  const [facultyList, setFacultyList] = useState([]);
  const [totalQuest, setTotalQuest] = useState({
    SubTotalQuest: [],
    Topic: [],
  });
  const [uniqueArr, setUniqueArr] = useState([]);
  // const [cstmArr, setCstmArr] = useState({});
  const [cstmObj, setCstmObj] = useState({});
  const [rawBatchData, setRawBatchData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [commonData, setCommonData] = useState({
    center: [],
    phase: [],
    session: [],
    stclass: [],
    target: [],
  });
  const ids = useId();
  const [reqData, setReqData] = useState(requestedData);
  const randomFn = (datas, subtotalQues) => {
    let subjects = datas.Subjects;
    for (const subject in subjects) {
      const subjectArr = subjects[subject];
      for (let j = 0; j < subjectArr.length; j++) {
        const sectionArr = subjects[subject].filter(
          (x) => x.sec_id == subjectArr[j].sec_id
        );

        console.log("sectionArr",sectionArr)
        // let additionOfQuestion = sectionArr
        //   .reduce(function (accumulator, object) {
        //     return accumulator + object.question;
        //   }, 0);
        
          const availableNoOfQuestions = subtotalQues.SubTotalQuest.filter(
            (y) =>
              y["TblSubject.sub_name"] === subject &&
              y["TblSection.section_id"] == subjectArr[j].sec_id
          )[0].num_questions;

          // for (let i = 0; i < sectionArr.length; i++) {
            
          // }
        subjects[subject][j] = {
          ...subjects[subject][j],
          sec_id: subjectArr[j].sec_id,
          question: subjectArr[j].question,
          num_questions:
          sectionArr.length === 1 
              ? availableNoOfQuestions
              : sectionArr[0].user_id == subjectArr[j].user_id  ? availableNoOfQuestions : availableNoOfQuestions - subjectArr[j-1].question,
        };

        // num_questions:
          //   sectionArr.length === 1
          //     ? availableNoOfQuestions
          //     : availableNoOfQuestions - additionOfQuestion,

      }
    }
    
    return subjects;
  };
  const getOnLoadData = (allFaculty) => {
    userService
      .getReqpaperData(pid)
      .then((res) => {
        const datas = res.data.data;
        const centerdata = datas.pcenters.map((data) => {
          return {
            center_id: data.center_id,
            center: data["TblCenter.center"],
          };
        });
        setFacultyDataOnLoad(centerdata, allFaculty);
        const classData = datas.pclasses.map((data) => {
          return { class_id: data.class_id, class: data["TblClass.Class"] };
        });
        const subList = [];
        for (const sub in datas.Subjects) {
          subList.push(sub);
        }
        console.log("centerdata", centerdata);
        fetchFormatList(datas.target_id);

        
        
        const reqDataFn = (subtotalQues) => {
          setReqData((prev) => {
            let modifiedSubjects = randomFn(datas, subtotalQues);
            userService
      .getTotalQues(datas.paper_format_id)
      .then((data) => {
       const topicData = data.data.data;
       
       for (let obj in modifiedSubjects) {
        modifiedSubjects[obj] = modifiedSubjects[obj].map((x) => {
          return {
            ...x,
            topic_id: x.topic_id.split(",").map((y) => {
              return { topic_id: y,
                 topic_name:topicData.Topic.filter(x => x.topic_id == y)[0]?.topic_name
                };
            }),
          };
        });
      }
      })
      .catch(err => console.error(err));

      console.log("modifiedSubjects",modifiedSubjects)
            
            return {
              ...prev,
              ...datas,
              pcenters: centerdata,
              pclasses: classData,
              batchsrel: isEmpty(datas.batchrel)
                ? [{ batch_id: 0 }]
                : datas.batchrel,
              Sublist: subList,
              to_be_held_on: new Date(datas.to_be_held_on),
              to_be_completed_by: new Date(datas.to_be_completed_by),
              to_be_final_by: new Date(datas.to_be_final_by),
              start_date: new Date(datas.start_date),
              end_date: new Date(datas.end_date),
              Subjects: modifiedSubjects,
            };
          });
        };
        setQuestionSection(datas.paper_format_id, false, reqDataFn);

        //
        // for(let i = 0; i < uniqueArr.length; i++){
        //   const subject = uniqueArr[i]["TblSubject.sub_name"];
        
        // }

        //
        const classes = new Array(classData.length);
        if (
          datas.target_id !== "" &&
          classData.length > 0 &&
          datas.session_id !== ""
        ) {
          for (let i = 0; i < datas.pclasses.length; i++) {
            // const index = selectClasses.indexOf(selectClasses[i]);
            classes[i] = "'" + convertClassId[classData[i].class_id] + "'";
          }
          const body = {
            target: datas.target_id,
            class: "[" + classes + "]",
            session: convertSessionId[datas.session_id],
          };
          getBatches(body);
        }
        // setTimeout(() => {
          for (let i = 0; i < forms.current.length; i++) {
            if (forms.current[i].parentNode.id.includes("multiselect1")) {
              forms.current[i].required = true;
              // For centers multiselect
              if (centerdata.length > 0) {
                document.getElementById(
                  forms.current[i].parentNode.id
                ).style.border = "none";
                document
                  .getElementById(forms.current[i].parentNode.id)
                  .querySelector("#search_input").required = false;
              } else {
                document
                  .getElementById(forms.current[i].parentNode.id)
                  .querySelector("#search_input").required = true;
                document.getElementById(
                  forms.current[i].parentNode.id
                ).style.border = "1px solid red";
              }
            }
            // For classes multiselect
            if (forms.current[i].parentNode.id.includes("multiselect2")) {
              forms.current[i].required = true;
              if (classData.length > 0) {
                document.getElementById(
                  forms.current[i].parentNode.id
                ).style.border = "none";
                document
                  .getElementById(forms.current[i].parentNode.id)
                  .querySelector("#search_input").required = false;
              } else {
                document.getElementById(
                  forms.current[i].parentNode.id
                ).style.border = "1px solid red";
                document
                  .getElementById(forms.current[i].parentNode.id)
                  .querySelector("#search_input").required = true;
              }
            }
          }
        // }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    for (let i = 0; i < forms.current.length; i++) {
      if (forms.current[i].className.includes("searchBox")&& !forms.current[i].parentNode.parentNode.className.includes('notrequiredmultiselect')){
        forms.current[i].required = true;
        forms.current[i].parentNode.id = "multiselect"+i+ids;
      } else {
        forms.current[i].required = false;
      }
    }
    setLoader(true);
    userService
      .getCommonList()
      .then((data) => {
        setCommonData(data.data.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
    userService
      .getUserList()
      .then((data) => {
        const datas = data.data.data.filter((y) => y.active == 1);
        setAllFacultyList(datas);
        if (pid !== undefined) {
          getOnLoadData(datas);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  // useEffect(() => {
  //   setLoader(true);
  //   userService
  //     .getCommonList()
  //     .then((data) => {
  //       setCommonData(data.data.data);
  //       setLoader(false);
  //     })
  //     .catch((err) => {
  //       setLoader(false);
  //       console.log(err);
  //     });
  //   userService
  //     .getUserList()
  //     .then((data) => {
  //       const datas = data.data.data.filter(y => y.active == 1)
  //       setAllFacultyList(datas);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);
  const getBatches = (body) => {
    setLoader(true);
    userService
      .getBatchData(body)
      .then((data) => {
        setLoader(false);
        setRawBatchData(data.response.data);
        return data;
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  const convertClassId = {
    1: "11",
    2: "12",
    3: "13",
    4: "9",
    5: "10",
  };
  const convertSessionId = {
    1: "18",
    2: "19",
    3: "20",
    4: "21",
    5: "22",
  };
  const onSelectSession = (e) => {
    // setSelectSession(e.target.value)
    e.target.style.border = "none";
    setReqData((prev) => {
      return {
        ...prev,
        session_id: +e.target.value,
      };
    });
    const classes = new Array(reqData.pclasses.length);
    if (reqData.target_id !== "" && reqData.pclasses.length > 0) {
      for (let i = 0; i < reqData.pclasses.length; i++) {
        // const index = selectClasses.indexOf(selectClasses[i]);
        classes[i] = "'" + convertClassId[reqData.pclasses[i].class_id] + "'";
      }
      const body = {
        target: reqData.target_id,
        class: "[" + classes + "]",
        session: convertSessionId[e.target.value],
      };
      getBatches(body);
    }
  };
  const setFacultyDataOnLoad = (centerList, allFacultyLis) => {
    let facData = [];
    for (let i = 0; i < centerList.length; i++) {
      facData.push(
        ...allFacultyLis.filter(
          (y) => y["TblCenter.center"] == centerList[i].center
        )
      );
    }
    // if(facData)
    console.log(facData);
    setFacultyList(facData);
    setTimeout(() => {
      console.log(facultyList);
    }, 3000);
  };
  const selectCenter = (selectedList, selectedItem, id) => {
    // setSelectedCenter(selectedList)
    console.log("selectedList", selectedList);
    if (selectedList.length > 0) {
      document.getElementById(id).style.border = "none";
      document
        .getElementById(id)
        .querySelector("#search_input").required = false;
    } else {
      document
        .getElementById(id)
        .querySelector("#search_input").required = true;
      document.getElementById(id).style.border = "1px solid red";
    }
    let facData = [];
    for (let i = 0; i < selectedList.length; i++) {
      facData.push(
        ...allFacultyList.filter(
          (y) => y["TblCenter.center"] == selectedList[i].center
        )
      );
    }
    // if(facData)
    setFacultyList(facData);
    console.log("facData", facData, selectedList);
    setReqData((prev) => {
      return { ...prev, pcenters: selectedList };
    });
  };
  const removeCenter = (selectedList, selectedItem, id) => {
    // setSelectedCenter(selectedList)
    if (selectedList.length > 0) {
      document.getElementById(id).style.border = "none";
      document
        .getElementById(id)
        .querySelector("#search_input").required = false;
    } else {
      document.getElementById(id).style.border = "1px solid red";
      document
        .getElementById(id)
        .querySelector("#search_input").required = true;
    }
    let facData = [];
    for (let i = 0; i < selectedList.length; i++) {
      facData.push(
        ...allFacultyList.filter(
          (y) => y["TblCenter.center"] == selectedList[i].center
        )
      );
    }
    setFacultyList(facData);
    setReqData((prev) => {
      return { ...prev, pcenters: selectedList };
    });
  };
  const selectClass = (selectedList, selectedItem, id) => {
    const result = selectedList.map((x) => x.class_id);
    // setSelectClasses(selectedList)
    if (selectedList.length > 0) {
      document.getElementById(id).style.border = "none";
      document
        .getElementById(id)
        .querySelector("#search_input").required = false;
    } else {
      document.getElementById(id).style.border = "1px solid red";
      document
        .getElementById(id)
        .querySelector("#search_input").required = true;
    }
    setReqData((prev) => {
      return { ...prev, pclasses: selectedList };
    });
    const classes = new Array(selectedList.length);
    if (reqData.session_id !== "" && reqData.target_id !== "") {
      for (let i = 0; i < selectedList.length; i++) {
        classes[i] = "'" + convertClassId[selectedList[i].class_id] + "'";
      }
      const body = {
        target: reqData.target_id,
        class: "[" + classes + "]",
        session: convertSessionId[reqData.session_id],
      };
      getBatches(body);
    }
  };
  const removeClass = (selectedList, selectedItem, id) => {
    const result = selectedList.map((x) => x.class_id);
    // setSelectClasses(selectedList)
    if (selectedList.length > 0) {
      document.getElementById(id).style.border = "none";
      document
        .getElementById(id)
        .querySelector("#search_input").required = false;
    } else {
      document.getElementById(id).style.border = "1px solid red";
      document
        .getElementById(id)
        .querySelector("#search_input").required = true;
    }
    setReqData((prev) => {
      return { ...prev, pclasses: selectedList };
    });
    const classes = new Array(selectedList.length);
    if (reqData.session_id !== "" && reqData.target_id !== "") {
      for (let i = 0; i < selectedList.length; i++) {
        classes[i] = "'" + convertClassId[selectedList[i].class_id] + "'";
      }
      const body = {
        target: reqData.target_id,
        class: "[" + classes + "]",
        session: convertSessionId[reqData.session_id],
      };
      getBatches(body);
    }
  };
  const fetchFormatList = (streamId) => {
    setLoader(true);
    userService
      .getPaperFormatByTrgt(streamId)
      .then((data) => {
        setLoader(false);
        setFormatList(data.data);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  const onSelectStream = (e) => {
    e.target.style.border = "none";
    setReqData((prev) => {
      return { ...prev, paper_format_id: "", target_id: +e.target.value };
    });
    fetchFormatList(e.target.value);
    const classes = new Array(reqData.pclasses.length);
    if (reqData.session_id !== "" && reqData.pclasses.length > 0) {
      for (let i = 0; i < reqData.pclasses.length; i++) {
        classes[i] = "'" + convertClassId[reqData.pclasses[i].class_id] + "'";
      }
      const body = {
        target: e.target.value,
        class: "[" + classes + "]",
        session: convertSessionId[reqData.session_id],
      };
      getBatches(body);
    }
  };

  const setQuestionSection = (formatId, dataSetting, fn) => {
    setShowQDetails(false);
    userService
      .getTotalQues(formatId)
      .then((data) => {
        const datas = data.data.data;
        const x = datas.SubTotalQuest;
        setTotalQuest(data.data.data);
        const removeDuplicates = (originalArray, prop) => {
          let newArray = [];
          let lookupObject = {};

          for (let i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
          }

          for (let i in lookupObject) {
            newArray.push(lookupObject[i]);
          }
          return newArray;
        };

        setUniqueArr(() => removeDuplicates(x, "TblSubject.sub_name"));
        const dda = (uniqueArray) => {
          const obj = {};
          for (let i = 0; i < uniqueArray.length; i++) {
            const sub_name = uniqueArray[i]["TblSubject.sub_name"];
            const arr = x.filter((y) => y["TblSubject.sub_name"] === sub_name);
            obj[sub_name] = new Array(arr.length);
            for (let j = 0; j < arr.length; j++) {
              obj[sub_name][j] = {
                ...arr[j],
                num_questions: "",
                sub_id: "",
                sec_id: "",
                user_id: "",
                question: "",
                topic_id: [],
                topic_remark: "",
                assigned_by: user.user_id,
                assigned_on: new Date()
                  .toLocaleString("sv-SE")
                  .replace(",", ""),
                status: 1,
              };
            }
          }
          return obj;
        };
        const dda1 = (uniqueArray) => {
          const array = new Array(uniqueArray.length);
          for (let i = 0; i < uniqueArray.length; i++) {
            array[i] = uniqueArray[i]["TblSubject.sub_name"];
          }
          return array;
        };
        // setCstmArr(dda(removeDuplicates(x, "TblSubject.sub_name")));
        setCstmObj(dda(removeDuplicates(x, "TblSubject.sub_name")));
        if (dataSetting) {
          setReqData((prev) => {
            return {
              ...prev,
              Sublist: [...dda1(removeDuplicates(x, "TblSubject.sub_name"))],
              Subjects: { ...dda(removeDuplicates(x, "TblSubject.sub_name")) },
            };
          });
        } else {
          fn(datas);
        }
        setShowQDetails(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSelectFormat = (e) => {
    // setSelectedFormat(e.target.value);
    e.target.style.border = "none";
    setReqData((prev) => {
      // const datas1 = {...prev}
      const datas = { ...cstmObj };
      // remove object properties if exist on another object
      // Iterate over object keys
      Object.keys(prev).forEach((prop) => {
        // Check if the "original" object has the property defined
        if (datas.hasOwnProperty(prop)) {
          // Delete the property from the "prev" object
          // shri ram jai ram jai jai ram
          delete prev[prop];
        }
      });
      return { ...prev, paper_format_id: +e.target.value };
    });

    setQuestionSection(e.target.value, true);
  };
  // const popUpHandler = () => {
  //   setShowPopUp1(true);
  // };
  const onHideHandler = () => {
    setShowPopUp1(false);
    setShowPopUp2(false);
  };
  const savePaperRequest = () => {
    setLoader(true);
    let modifiedSubjects = {...reqData.Subjects};
    for (let obj in modifiedSubjects) {
      modifiedSubjects[obj] = modifiedSubjects[obj].map((x) => {
        return { ...x, topic_id: x.topic_id.map((y) => y.topic_id).join() };
      });
    }
    let body = {
      ...reqData,
      Subjects: modifiedSubjects,
      paper_id: pid,
      end_date: reqData.end_date.toLocaleString("sv-SE").replace(",", ""),
      start_date: reqData.start_date.toLocaleString("sv-SE").replace(",", ""),
      to_be_completed_by:
      reqData.to_be_completed_by.toLocaleDateString("sv-SE"),
      to_be_held_on: reqData.to_be_held_on.toLocaleDateString("sv-SE"),
      to_be_final_by: reqData.to_be_final_by.toLocaleDateString("sv-SE"),
    };
    // 
    userService
      .updateRequestPaper(body)
      .then((data) => {
        setLoader(false);
        setShowPopUp2(true);
        // setReqData(requestedData)
        // setReqData(requestedData);
        setTimeout(() => {
          navigate("/editPaper")
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
        toast.error("Something went wrong !!");
      });
  }
  const yesHandler = () => {
    setShowPopUp1(false);
    if (!finalTotalQues()) {
      toast.error("Please select the total number of questions.");
      return;
    }
    savePaperRequest();
  };
  const qNumberFn = (num) => {
    // const qNumberFn = (data) => {
    // const arr = totalQuest.SubTotalQuest.filter(
    //   (x) => x["TblSubject.sub_name"] === data["TblSubject.sub_name"]
    // );
    // let sum = arr.reduce(function (x, y) {
    //   return x + y.num_questions;
    // }, 0);
    return Array.from({ length: num }, (_, index) => index + 1);
  };
  // const qNumberFn = (data) => {
  //   const arr = totalQuest.SubTotalQuest.filter(
  //     (x) => x["TblSubject.sub_name"] === data["TblSubject.sub_name"]
  //   );
  // let sum = arr.reduce(function (x, y) {
  //   return x + y.num_questions;
  // }, 0); 
  // jai shree ram
  //   return Array.from({ length: data }, (_, index) => index + 1);
  // };
  const copyHandler = (subName, data) => {
    // setCstmArr(prev => {
    //  return{
    //   ...prev,
    //   [subName] : [...prev[subName],{...data,"sub_id": "",
    //   "sec_id": "",
    //   "user_id": "",
    //   "question": "",
    //   "topic_id": "",
    //   "topic_remark": "",
    //   "assigned_by":JSON.parse(localStorage.getItem('user')).data.user_id ,
    //   "assigned_on":new Date().toLocaleString(),
    //   "status": 1}]
    // };
    // })
    setReqData((prev) => {
      return {
        ...prev,
        Subjects: {
          ...prev.Subjects,
          [subName]: [
            ...(prev.Subjects[subName] || []),
            {
              ...data,
              sub_id: "",
              sec_id: "",
              user_id: "",
              num_questions: "",
              question: "",
              topic_id: [],
              topic_remark: "",
              assigned_by: JSON.parse(localStorage.getItem("user")).data.user
                .user_id,
              assigned_on: new Date().toLocaleString(),
              status: 1,
            },
          ],
        },
      };
    });
  };
  const closeHandler = (subName, i) => {
    // setCstmArr(prev => {
    //   const data = prev[subName].splice(i,1)
    //  return{
    //   ...prev,
    //   [subName] : prev[subName]
    // };
    // })
    setReqData((prev) => {
      const data = prev.Subjects[subName].splice(i, 1);
      return {
        ...prev,
        Subjects: { ...prev.Subjects, [subName]: prev.Subjects[subName] },
      };
    });
  };
  const submitHandler = (e) => {
    e.preventDefault();
    setShowPopUp1(true);
  };
  // const finalTotalQues = () => {
  //   let total_Questions = 0;
  //   let totalRequestedQuestion = 0;
  //   for (let i = 0; i < uniqueArr.length; i++) {
  //     let a = totalQuest.SubTotalQuest.filter(
  //       (x) => x["TblSubject.sub_name"] === uniqueArr[i]["TblSubject.sub_name"]
  //     );
  //     for (let i = 0; i < a.length; i++) {
  //       total_Questions += a[i].num_questions;
  //     }
  //     let b = reqData.Subjects[uniqueArr[i]["TblSubject.sub_name"]];
  //     console.log("reqDadada", b);
  //     for (let i = 0; i < a.length; i++) {
  //       totalRequestedQuestion += +b[i].question;
  //     }
  //   }
//   jai shree ram
  //   console.log([total_Questions, totalRequestedQuestion]);
  //   return total_Questions == totalRequestedQuestion;
  // };
  const finalTotalQues = () => {
    let total_Questions = 0;
    let totalRequestedQuestion = 0;
    const sublist = reqData.Sublist;
    for (let i = 0; i < sublist.length; i++) {
      let a = totalQuest.SubTotalQuest.filter(
        (x) => x["TblSubject.sub_name"] === sublist[i]
      );
      for (let i = 0; i < a.length; i++) {
        total_Questions += a[i].num_questions;
      }
      let b = reqData.Subjects[sublist[i]];
      for (let i = 0; i < b.length; i++) {
        totalRequestedQuestion += +b[i].question;
      }
    }

    console.log([total_Questions, totalRequestedQuestion]);
    return total_Questions == totalRequestedQuestion;
  };

  const removeSelectedFaculty = (subjectname, current_sec_id, i, sub_id) => {
    if(!current_sec_id){
      // console.log("!current_sec_id",facultyList.length,facultyList)
      const returnData = facultyList.filter(
        (z) =>
        z["TblUsersSubjectRels.sub_id"] ==
        sub_id
        ) 
        // console.log("!current_sec_id",returnData.length,returnData)
      return returnData;
    }
      const toRemove = reqData.Subjects[subjectname].slice(0,i).filter(d => d.sec_id == current_sec_id).map(d => d.user_id);
      // console.log("ToremoveArray",reqData.Subjects[subjectname].slice(0,i).filter(d => d.sec_id == current_sec_id));
      // console.log("Toremove",toRemove);

      if(toRemove.length == 0){
        const returnData = facultyList.filter(
          (z) =>
          z["TblUsersSubjectRels.sub_id"] ==
          sub_id
          ) 
          // console.log("toRemove.length == 0",returnData.length,returnData)
        return returnData;
      } else {
        const returnData = facultyList.filter(
          (z) =>
          z["TblUsersSubjectRels.sub_id"] ==
          sub_id
          ).filter((el) =>!toRemove.includes(el.user_id));
          // console.log("Final Data",returnData.length,returnData);
        return returnData;
      }
  }

  return (
    <>
      <Toast />
      <div className="section">
        {/* <button
          onClick={() => {
            console.log(reqData.batchsrel[0].batch_id);
            console.log("uniqueArr", uniqueArr);
            console.log("cstmObj", cstmObj);
            console.log("totalQuest", totalQuest);
            console.log("reqData", reqData);
            // console.log("start_date",reqData.start_date.toLocaleString("sv-SE").replace(',',''))
            // console.log("to_be_held_on",reqData.to_be_held_on.toLocaleDateString("sv-SE"))
            // jai shri ram
          }}
        >
          dgsd
        </button> */}
        <form ref={forms} onSubmit={submitHandler}>
          {loader && <Loader />}
          <ConfirmationModal
            title="Do you want to save this paper?"
            show={showPopUp1}
            onHide={onHideHandler}
            yesHandler={yesHandler}
            confirmTxt="Yes"
          />
          <SuccessModal
            show={showPopUp2}
            onHide={onHideHandler}
            title="Paper Updated Successfully!"
            btnTxt="Ok"
            // onClick={}
          />
          <h4>Request Paper</h4>
          <Breadcrumb>
            {/*<Breadcrumb.Item><Link to='/'> Home </Link></Breadcrumb.Item>*/}
            <Breadcrumb.Item active>Request Paper</Breadcrumb.Item>
          </Breadcrumb>
          <Graybg>
            <p className={classes.text}>Basic Details</p>
            <Card>
              <Row className="gx-3 gy-2">
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="session">Session :</Form.Label>
                  <Select
                    required
                    className={classes.select}
                    value={reqData.session_id}
                    onChange={onSelectSession}
                  >
                    <option value="" disabled>
                      Choose session
                    </option>
                    {commonData.session.map((data) => {
                      return (
                        <option
                          value={data.session_id}
                          key={data.session_id + data.session}
                        >
                          {data.session}
                        </option>
                      );
                    })}
                  </Select>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="Center">Center :</Form.Label>
                  {/* <MultiSelect /> */}
                  <MultiSelectDropdown
                    placeholder="Select Center"
                    options={commonData.center}
                    selectedValues={reqData.pcenters}
                    displayValue="center"
                    onSelect={(selectedList, selectedItem) =>
                      selectCenter(
                        selectedList,
                        selectedItem,
                        "multiselect1" + ids
                      )
                    }
                    onRemove={(selectedList, selectedItem) =>
                      removeCenter(
                        selectedList,
                        selectedItem,
                        "multiselect1" + ids
                      )
                    }
                  />
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="Class">Class :</Form.Label>
                  <MultiSelectDropdown
                    placeholder="Select Class"
                    options={commonData.stclass}
                    selectedValues={reqData.pclasses}
                    displayValue="class"
                    onSelect={(selectedList, selectedItem) =>
                      selectClass(
                        selectedList,
                        selectedItem,
                        "multiselect2" + ids
                      )
                    }
                    onRemove={(selectedList, selectedItem) =>
                      removeClass(
                        selectedList,
                        selectedItem,
                        "multiselect2" + ids
                      )
                    }
                  />
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="Phase">Phase</Form.Label>
                  <Select
                    required
                    value={reqData.phase_id}
                    onChange={(e) =>
                      setReqData((prev) => {
                        return { ...prev, phase_id: +e.target.value };
                      })
                    }
                  >
                    <option value="" disabled>
                      Select Phase
                    </option>
                    {commonData.phase.map((data) => {
                      return (
                        <option
                          value={data.phase_id}
                          key={data.phase + data.phase_id}
                        >
                          {data.phase}
                        </option>
                      );
                    })}
                  </Select>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="Stream">Stream</Form.Label>
                  <Select
                    value={reqData.target_id}
                    onChange={onSelectStream}
                    required
                  >
                    <option value="" disabled>
                      Select Stream
                    </option>
                    {commonData.target.map((data) => {
                      return (
                        <option
                          value={data.target_id}
                          key={data.target + data.target_id}
                        >
                          {data.target}
                        </option>
                      );
                    })}
                  </Select>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="Batch">
                    Batch{" "}
                    {(reqData.session_id == "" ||
                      reqData.target_id === "" ||
                      reqData.pclasses.length === 0) && (
                      <span style={{ fontSize: "10px", color: "red" }}>
                        (Select {reqData.session_id === "" && "session,"}
                        {reqData.pclasses.length === 0 && "class,"}{" "}
                        {reqData.target_id === "" && "stream"})
                      </span>
                    )}
                  </Form.Label>
                  <Select
                    value={reqData.batchsrel[0].batch_id}
                    onChange={(e) =>
                      setReqData((prev) => {
                        return {
                          ...prev,
                          batchsrel: [{ batch_id: e.target.value }],
                        };
                      })
                    }
                    // required
                    disabled={
                      reqData.session_id === "" ||
                      reqData.target_id === "" ||
                      reqData.pclasses.length === 0
                    }
                  >
                    <option value={0} disabled>
                      {rawBatchData.filter((x) => x.active !== "0").length ===
                        0 &&
                      (reqData.session_id !== "" ||
                        reqData.target_id !== "" ||
                        reqData.pclasses.length !== 0)
                        ? "No Batch available"
                        : "Select Batch"}
                    </option>
                    {rawBatchData
                      .filter((x) => x.active !== "0")
                      .map((data) => {
                        return (
                          <option
                            key={data.id + data.classroom_batch_name}
                            value={data.id}
                          >
                            {data.classroom_batch_name}
                          </option>
                        );
                      })}
                  </Select>
                </Col>
                <Col sm={12}>
                  <Form.Label htmlFor="Paper_format">Paper format</Form.Label>
                  <Select
                    required
                    disabled={reqData.target_id == ""}
                    value={reqData.paper_format_id}
                    onChange={onSelectFormat}
                  >
                    <option value="" disabled>
                      {reqData.target_id == ""
                        ? "Select Stream First"
                        : "Select Paper format"}
                    </option>
                    {formatList.map((data) => {
                      return (
                        <option value={data.format_id}>
                          {data.paper_format}
                        </option>
                      );
                    })}
                  </Select>
                </Col>
                <Col sm={12}>
                  <Form.Label htmlFor="Paper_title">Paper title</Form.Label>
                  <Input
                    required
                    type="text"
                    placeholder="Select Paper title"
                    value={reqData.paper_name}
                    onChange={(e) => {
                      e.target.style.border = "none";
                      // setReqData((prev) => {
                      //   return { ...prev, paper_type: e.target.value };
                      // })
                      setReqData((prev) => {
                        return {
                          ...prev,
                          paper_name: e.target.value,
                        };
                      });
                    }}
                  />
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="Batch">Exam Date :</Form.Label>
                  <DatePick
                  minDate={new Date()}
                    required={true}
                    placeholder="Select Exam Date"
                    selected={reqData.to_be_held_on}
                    onChange={(date) =>
                      setReqData((prev) => {
                        return { ...prev, to_be_held_on: date };
                      })
                    }
                  />
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="Batch">
                    Last date to create paper :
                  </Form.Label>
                  <DatePick
                  minDate={new Date()}
                    required={true}
                    placeholder={
                      reqData.to_be_held_on === ("" || null)
                        ? "Select Exam date first!!"
                        : "Select Deadline"
                    }
                    disabled={
                      reqData.to_be_held_on === ("" || null) ? true : false
                    }
                    maxDate={subDays(reqData.to_be_held_on, 1)}
                    selected={reqData.to_be_completed_by}
                    onChange={(date) =>
                      setReqData((prev) => {
                        return { ...prev, to_be_completed_by: date };
                      })
                    }
                  />
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="Batch">Paper Start Time :</Form.Label>
                  <DatePick
                    selected={reqData.start_date}
                    required={true}
                    onChange={(date) =>
                      setReqData((prev) => {
                        return { ...prev, start_date: date };
                      })
                    }
                    placeholder={
                      reqData.to_be_held_on === ("" || null)
                        ? "Select Exam date first!!"
                        : "Select Paper Start Time"
                    }
                    disabled={
                      reqData.to_be_held_on === ("" || null) ? true : false
                    }
                    minDate={reqData.to_be_held_on}
                    maxDate={reqData.to_be_held_on}
                    // placeholder="Select Paper Start Time"
                    timeInputLabel="Time:"
                    dateFormat="dd-MM-yy hh:mm aa"
                    // showTimeInput
                    showTimeSelect
                    timeIntervals={15}
                  />
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="Batch">Paper End Time :</Form.Label>
                  <DatePick
                    selected={reqData.end_date}
                    onChange={(date) => {
                      console.log(date);
                      setReqData((prev) => {
                        return { ...prev, end_date: date };
                      });
                    }}
                    required={true}
                    placeholder={
                      reqData.start_date === ("" || null)
                        ? "Select Paper Start Time first !"
                        : "Select Paper End Time"
                    }
                    minDate={reqData.start_date}
                    maxDate={reqData.start_date}
                    minTime={setHours(setMinutes(reqData.start_date, 0), 5)}
                    maxTime={setHours(setMinutes(reqData.start_date, 0), 22)}
                    timeInputLabel="Time:"
                    dateFormat="dd-MM-yy hh:mm aa"
                    showTimeSelect
                    timeIntervals={15}
                    disabled={
                      reqData.start_date === ("" || null) ? true : false
                    }
                  />
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="Batch">Finalization Date :</Form.Label>
                  <DatePick
                  minDate={new Date()}
                    required={true}
                    // placeholder="Select Finalization Date"
                    selected={reqData.to_be_final_by}
                    onChange={(date) =>
                      setReqData((prev) => {
                        return { ...prev, to_be_final_by: date };
                      })
                    }
                    placeholder={
                      reqData.to_be_held_on === ("" || null)
                        ? "Select Exam date first!!"
                        : "Select Finalization Date"
                    }
                    disabled={
                      reqData.to_be_held_on === ("" || null) ? true : false
                    }
                    maxDate={subDays(reqData.to_be_held_on, 1)}
                  />
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="Batch">Paper Type</Form.Label>
                  <Select
                    required
                    value={reqData.paper_type}
                    onChange={(e) => {
                      e.target.style.border = "none";
                      setReqData((prev) => {
                        return { ...prev, paper_type: e.target.value };
                      });
                    }}
                  >
                    <option value="" disabled>
                      Select Paper Type
                    </option>
                    <option value="Free">Free</option>
                    <option value="Paid">Paid</option>
                  </Select>
                </Col>
              </Row>
            </Card>
            {reqData.paper_format_id !== "" && showQDetails && (
              <>
                <p className={classes.text1}>Paper Creating Faculty Details</p>
                {uniqueArr.map((data, index) => {
                  return (
                    <>
                      {/* <FacultyCreation
                            index={index}
                            totalQuest={totalQuest}
                            data={data}
                            copyHandler={copyHandler}
                            // qNumberFn={qNumberFn}
                            facultyList={facultyList}
                            cstmArr={cstmArr}
                            closeHandler={closeHandler}
                          /> */}
                          <Card>
                        <div className="text-end">
                          {totalQuest.SubTotalQuest.filter(
                            (x) =>
                              x["TblSubject.sub_name"] ===
                              data["TblSubject.sub_name"]
                          )
                            .sort(
                              (a, b) =>
                                a["TblSection.section_id"] -
                                b["TblSection.section_id"]
                            )
                            .map((y, i) => {
                              return (
                                <p>
                                  Total {y["TblSubject.sub_name"]}{" "}
                                  {y["TblSection.section_name"]}
                                  {" Questions : "}
                                  {y.num_questions}
                                </p>
                              );
                            })}
                          {/* When all the total question number selected, the condition for not showing the add new row */}
                          {reqData.Subjects[data["TblSubject.sub_name"]]?.reduce(
                            (accumulator, object) =>
                              accumulator + object.question,
                            0
                          ) !=
                          totalQuest.SubTotalQuest.filter(
                            (y) =>
                              y["TblSubject.sub_name"] ===
                              data["TblSubject.sub_name"]
                          ).reduce(
                            (accumulator, object) =>
                              accumulator + object.num_questions,
                            0
                          ) ? (
                            <SecBTN
                              type="button"
                              className={classes["reqPaper-btn"]}
                              onClick={() =>
                                copyHandler(data["TblSubject.sub_name"], data)
                              }
                            >
                              Add {data["TblSubject.sub_name"]} Row
                            </SecBTN>
                          ) : (
                            <SecBTN
                              type="button"
                              className={classes["reqPaper-btn_disabled"]}
                            >
                              Add {data["TblSubject.sub_name"]} Row
                            </SecBTN>
                          )}
                          

                          {reqData.Subjects[data["TblSubject.sub_name"]]?.map(
                            (x, i) => {
                              return (
                                <>
                                  {/*                                 
                                <SubjectCard 
                                  x={x}
                                  i={i}
                                  qNumberFn={qNumberFn}
                                  closeHandler={closeHandler}
                                  reqData={reqData}
                                  totalQuest={totalQuest}
                                  data={data}
                                  facultyList={facultyList}
                                  setReqData={setReqData}
                                /> */}
                                  <Card
                                    className={classes["reqPaper-card"]}
                                    key={i + JSON.stringify(x) + ids}
                                  >
                                    <div className="d-flex flex-row justify-content-between align-items-center">
                                      <p className={classes.text}>
                                        {data["TblSubject.sub_name"]}
                                      </p>
                                      {i !== 0 && (
                                        <button
                                          type="button"
                                          className={classes.clsBtn}
                                          onClick={() =>
                                            closeHandler(
                                              data["TblSubject.sub_name"],
                                              i
                                            )
                                          }
                                        >
                                          <i className="bx bx-x"></i>
                                        </button>
                                      )}
                                    </div>
                                    <div className={classes["reqPaper-grid"]}>
                                      <div>
                                        <Form.Label htmlFor="Class">
                                          Section :
                                        </Form.Label>
                                        <Select
                                          required
                                          value={
                                            reqData.Subjects[
                                              data["TblSubject.sub_name"]
                                            ][i].sec_id
                                          }
                                          onChange={(e) => {
                                            const datas = { ...reqData };
                                            const sectionArr = datas.Subjects[
                                              x["TblSubject.sub_name"]
                                            ].filter(
                                              (x) => x.sec_id == +e.target.value
                                            );
                                            let additionOfQuestion =
                                              sectionArr.reduce(function (
                                                accumulator,
                                                object
                                              ) {
                                                return (
                                                  accumulator + object.question
                                                );
                                              },
                                              0);
                                            const availableNoOfQuestions =
                                              totalQuest.SubTotalQuest.filter(
                                                (y) =>
                                                  y["TblSubject.sub_name"] ===
                                                    x["TblSubject.sub_name"] &&
                                                  y["TblSection.section_id"] ==
                                                    e.target.value
                                              )[0].num_questions;

                                            datas.Subjects[
                                              x["TblSubject.sub_name"]
                                            ][i] = {
                                              ...datas.Subjects[
                                                x["TblSubject.sub_name"]
                                              ][i],
                                              sec_id: +e.target.value,
                                              question: "",
                                              num_questions:
                                                availableNoOfQuestions -
                                                additionOfQuestion,
                                            };
                                            setReqData(datas);
                                          }}
                                        >
                                          <option value="" disabled>
                                            Select Section
                                          </option>
                                          {totalQuest.SubTotalQuest.filter(
                                            (z) =>
                                              z["TblSubject.sub_name"] ===
                                              data["TblSubject.sub_name"]
                                          )
                                            .sort(
                                              (a, b) =>
                                                a["TblSection.section_id"] -
                                                b["TblSection.section_id"]
                                            )
                                            .map((y, i) => {
                                              return (
                                                <SectionOption
                                                  key={
                                                    y[
                                                      "TblSection.section_name"
                                                    ] +
                                                    y["TblSection.section_id"] +
                                                    ids
                                                  }
                                                  value={
                                                    y["TblSection.section_id"]
                                                  }
                                                  reqData={reqData}
                                                  totalQuest={totalQuest}
                                                  xSubName={
                                                    data["TblSubject.sub_name"]
                                                  }
                                                  ySecId={
                                                    y["TblSection.section_id"]
                                                  }
                                                >
                                                  {y["TblSection.section_name"]}
                                                </SectionOption>
                                              );
                                            })}
                                        </Select>
                                      </div>
                                      <div>
                                        <Form.Label htmlFor="Class">
                                          Faculty :
                                        </Form.Label>
                                        <Select
                                          required
                                          value={
                                            reqData.Subjects[
                                              data["TblSubject.sub_name"]
                                            ][i].user_id
                                          }
                                          onChange={(e) => {
                                            const datas = { ...reqData };
                                            datas.Subjects[
                                              data["TblSubject.sub_name"]
                                            ][i] = {
                                              ...datas.Subjects[
                                                data["TblSubject.sub_name"]
                                              ][i],
                                              user_id: +e.target.value,
                                            };
                                            setReqData(datas);
                                          }}
                                        >
                                          <option value="" disabled>
                                            {removeSelectedFaculty(
                                              data["TblSubject.sub_name"],
                                              x.sec_id,
                                              i,
                                              data["TblSubject.sub_id"]
                                            ).length == 0
                                              ? "Faculty not available for Selected Centers"
                                              : "Select Faculty"}
                                          </option>
                                          {removeSelectedFaculty(
                                            data["TblSubject.sub_name"],
                                            x.sec_id,
                                            i,
                                            data["TblSubject.sub_id"]
                                          ).map((data) => {
                                            return (
                                              <option value={data.user_id}>
                                                {data.NAME}
                                              </option>
                                            );
                                          })}
                                        </Select>
                                      </div>
                                      <div>
                                        <Form.Label htmlFor="Question">
                                          Question :
                                        </Form.Label>
                                        <Select
                                          value={
                                            reqData.Subjects[
                                              data["TblSubject.sub_name"]
                                            ][i].question
                                          }
                                          required
                                          onChange={(e) => {
                                            const datas = { ...reqData };
                                            datas.Subjects[
                                              data["TblSubject.sub_name"]
                                            ][i] = {
                                              ...datas.Subjects[
                                                data["TblSubject.sub_name"]
                                              ][i],
                                              question: +e.target.value,
                                            };
                                            setReqData(datas);
                                          }}
                                        >
                                          <option value="" disabled>
                                            Select Question
                                          </option>
                                          {qNumberFn(
                                            reqData.Subjects[
                                              data["TblSubject.sub_name"]
                                            ][i].num_questions
                                          ).map((data) => {
                                            return (
                                              <option value={data}>
                                                {data}
                                              </option>
                                            );
                                          })}
                                        </Select>
                                      </div>
                                      <div>
                                        <Form.Label htmlFor="Class">
                                          Topic :
                                        </Form.Label>
                                        {/* <Select
                                          required
                                          value={
                                            reqData.Subjects[
                                              data["TblSubject.sub_name"]
                                            ][i].topic_id
                                          }
                                          onChange={(e) => {
                                            const datas = { ...reqData };
                                            datas.Subjects[
                                              data["TblSubject.sub_name"]
                                            ][i] = {
                                              ...datas.Subjects[
                                                data["TblSubject.sub_name"]
                                              ][i],
                                              topic_id: e.target.value,
                                              sub_id: data["TblSubject.sub_id"],
                                            };
                                            setReqData(datas);
                                          }}
                                        >
                                          <option value="" disabled>
                                            Select Topic
                                          </option>
                                          {totalQuest.Topic.filter(
                                            (x) =>
                                              x.sub_name ===
                                              data["TblSubject.sub_name"]
                                          ).map((y) => {
                                            return (
                                              <option value={y.topic_id}>
                                                {y.topic_name}
                                              </option>
                                            );
                                          })}
                                        </Select> */}
                                        <MultiSelectDropdown
                                          selectedValues={
                                            reqData.Subjects[
                                              data["TblSubject.sub_name"]
                                            ][i].topic_id
                                          }
                                          placeholder="Select Topic"
                                          options={totalQuest.Topic.filter(
                                            (x) =>
                                              x.sub_name ===
                                              data["TblSubject.sub_name"]
                                          ).map((x) => {
                                            return {
                                              topic_id: x.topic_id,
                                              topic_name: x.topic_name,
                                            };
                                          })}
                                          displayValue="topic_name"
                                          onSelect={(
                                            selectedList,
                                            selectedItem
                                          ) => {
                                            console.log(
                                              "selectedList",
                                              selectedList
                                            );
                                            const datas = { ...reqData };
                                            datas.Subjects[
                                              x["TblSubject.sub_name"]
                                            ][i] = {
                                              ...datas.Subjects[
                                                x["TblSubject.sub_name"]
                                              ][i],
                                              topic_id: selectedList,
                                              sub_id: data["TblSubject.sub_id"],
                                            };
                                            setReqData(datas);
                                          }}
                                          onRemove={(
                                            selectedList,
                                            selectedItem
                                          ) => {
                                            console.log(
                                              "selectedList",
                                              selectedList
                                            );
                                            const datas = { ...reqData };
                                            datas.Subjects[
                                              x["TblSubject.sub_name"]
                                            ][i] = {
                                              ...datas.Subjects[
                                                x["TblSubject.sub_name"]
                                              ][i],
                                              topic_id: selectedList,
                                              sub_id: data["TblSubject.sub_id"],
                                            };
                                            setReqData(datas);
                                          }}
                                        />
                                      </div>
                                      <div>
                                        <Form.Label htmlFor="Class">
                                          Remark :
                                        </Form.Label>
                                        <Input
                                          type="text"
                                          placeholder="Remark(If any)"
                                          value={
                                            reqData.Subjects[
                                              data["TblSubject.sub_name"]
                                            ][i].topic_remark
                                          }
                                          onChange={(e) => {
                                            const datas = { ...reqData };
                                            datas.Subjects[
                                              data["TblSubject.sub_name"]
                                            ][i] = {
                                              ...datas.Subjects[
                                                data["TblSubject.sub_name"]
                                              ][i],
                                              topic_remark: e.target.value,
                                            };
                                            setReqData(datas);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </Card>
                                </>
                              );
                            }
                          )}
                        </div>
                      </Card>
                    </>
                  );
                })}
                <div className={classes["section-btn"]}>
                  <SecBTN
                    type="submit"
                    className={classes["sec-btn"]}
                    onClick={() => {
                      console.log(forms.current.length, forms.current);
                      for (let i = 0; i < forms.current.length; i++) {
                        console.log(forms.current[i].type);
                        if (
                          forms.current[i].required === true &&
                          forms.current[i].value === ""
                        ) {
                          if (forms.current[i].className.includes("searchBox")) {
                            // forms.current[i].required = true;
                            if (
                              forms.current[i].parentNode.className.includes(
                                "searchWrapper"
                              )
                            ) {
                              forms.current[i].parentNode.style.border =
                                "1px solid red";
                            }
                          } else {
                            forms.current[i].style.border = "1px solid red";
                          }
                        } else if (forms.current[i].type == "button") {
                        } else {
                          forms.current[i].style.border = "none";
                        }
                      }
                    }}
                  >
                    Save Details
                  </SecBTN>
                </div>
              </>
            )}
          </Graybg>
        </form>
        {/* <SecBTN onClick={() => console.log('finalTotalQues',finalTotalQues())} >
              Total 
            </SecBTN> */}
      </div>
    </>
  );
});

export default EditRequestPaper;
